import React, { useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";
import moment from "moment";
import { Button, Col, Input, Label, Modal, ModalBody, ModalHeader, Row, Table } from "reactstrap";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";

const headers = () => ({ Authorization: `Bearer: ${localStorage.getItem("app_token")}` });
const fmtN = (v) => new Intl.NumberFormat("es-MX").format(v || 0);
const fmtM = (v) => new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(v || 0);

function ListadoLotes() {
  const { user } = useContext(AuthContext);
  const URL_LOTES = process.env.REACT_APP_URL_LOTES;
  const [lotes, setLotes] = useState([]);
  const [buscar, setBuscar] = useState("");
  const [existencia, setExistencia] = useState("Si");
  const [traza, setTraza] = useState(null);

  useEffect(() => {
    axios.get(`${URL_LOTES}?existencia=${existencia}`, { headers: headers() }).then((r) => setLotes(r.data)).catch(console.log);
  }, [URL_LOTES, existencia]);

  const visibles = useMemo(() => {
    const q = buscar.toLowerCase();
    return lotes.filter((l) => !q || `${l.lote} ${l.articulos?.codigo} ${l.articulos?.nombre}`.toLowerCase().includes(q));
  }, [lotes, buscar]);

  const verTraza = async (l) => {
    const r = await axios.get(`${URL_LOTES}/${l._id}/trazabilidad`, { headers: headers() });
    setTraza({ lote: l, ventas: r.data });
  };

  const estado = (c) => {
    if (!c) return null;
    const d = moment(c).diff(moment(), "days");
    if (d < 0) return <span className="badge-soft-danger">Caducado</span>;
    if (d <= 120) return <span className="badge-soft-warning">{d} dias</span>;
    return <span className="badge-soft-success">Vigente</span>;
  };

  if (!user.menu_inventarios) return <Header />;

  return (
    <>
      <Header />
      <div className="card container col-12">
        <div className="page-header">
          <div><h3 className="page-title">Lotes</h3><p className="page-subtitle">Caducidad, existencia y a quien se vendio cada lote</p></div>
        </div>
        <Row className="filter-row">
          <Col md={4}><Label>Buscar</Label><Input value={buscar} onChange={(e) => setBuscar(e.target.value)} placeholder="Lote o vino" /></Col>
          <Col md={3}><Label>Mostrar</Label><Input type="select" value={existencia} onChange={(e) => setExistencia(e.target.value)}><option value="Si">Con existencia</option><option value="">Todos</option></Input></Col>
        </Row>
        <Table size="sm" responsive className="mt-3">
          <thead><tr><th>Lote</th><th>Vino</th><th>Añada</th><th>Entrada</th><th>Recepcion</th><th>Caducidad</th><th className="text-right">Recibidas</th><th className="text-right">Existencia</th><th className="text-right">Costo real</th><th /></tr></thead>
          <tbody>
            {visibles.slice(0, 300).map((l) => (
              <tr key={l._id}>
                <td>{l.lote}</td><td>{l.articulos?.codigo} {l.articulos?.nombre}</td><td>{l.anada}</td><td>{l.fecha}</td><td>{l.compras?.idCompras}</td>
                <td>{l.caducidad || "-"} {estado(l.caducidad)}</td>
                <td className="text-right">{fmtN(l.cantidadInicial)}</td><td className="text-right negrita">{fmtN(l.cantidad)}</td>
                <td className="text-right td-money">{fmtM(l.costoUnitario)}</td>
                <td className="text-right"><Button size="sm" color="secondary" title="A quien se vendio" onClick={() => verTraza(l)}><i className="fas fa-route" /></Button></td>
              </tr>
            ))}
            {visibles.length === 0 && <tr><td colSpan={10} className="text-center">Sin lotes</td></tr>}
          </tbody>
        </Table>
      </div>
      <Modal size="lg" isOpen={!!traza} toggle={() => setTraza(null)}>
        <ModalHeader toggle={() => setTraza(null)}>Lote {traza?.lote.lote}</ModalHeader>
        <ModalBody>
          <Table size="sm" responsive>
            <thead><tr><th>Nota</th><th>Fecha</th><th>Cliente</th><th className="text-right">Botellas</th><th>Estado</th></tr></thead>
            <tbody>
              {(traza?.ventas || []).map((v, i) => (
                <tr key={i}><td>{v.nota}</td><td>{v.fecha}</td><td>{v.cliente}</td><td className="text-right">{fmtN(v.cantidad)}</td><td>{v.activa === "Si" ? "Activa" : "Cancelada"}</td></tr>
              ))}
              {traza && traza.ventas.length === 0 && <tr><td colSpan={5} className="text-center">Este lote no se ha vendido</td></tr>}
            </tbody>
          </Table>
        </ModalBody>
      </Modal>
    </>
  );
}

export default ListadoLotes;
